import styled from '@emotion/styled';
import { Button, theme } from '@travelnest/hui';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IProperty } from '../../../data/entities/property';
import { InfoCard } from '../info-card/InfoCard';
import StyledHeading from '../typography/StyledHeading';
import StyledText from '../typography/StyledText';
import { PropertyScoreWheel } from './PropertyScoreWheel';

const AnnotatedPictogramContainer = styled.div`
	display: grid;
	grid-template-columns: minmax(200px, 3fr) minmax(100px, 1fr);
	grid-gap: 26px;
	height: 100%;
	width: 100%;
`;

const AnnotationContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	justify-content: space-between;
	overflow: hidden;
`;

const AnnotationTextContainer = styled.div`
	margin: 0 0 16px 0;
`;

const AnnotationButtonContainer = styled.div``;

const StyledTitle = styled(StyledHeading)`
	color: ${theme.colors.LM_NU100};
	margin: 0 0 8px 0;
`;

const StyledParagraph = styled(StyledText)`
	color: ${theme.colors.LM_NU70T};
	margin: 0;
`;

type PropertyScoreSummaryCardProps = IProperty & { totalScore: number, calculatingState: boolean };

export const PropertyScoreSummaryCard: React.FC<PropertyScoreSummaryCardProps> =
	({ id, internal_name, totalScore }: PropertyScoreSummaryCardProps) => {
		const navigate = useNavigate();

		return (
			<InfoCard>
				<AnnotatedPictogramContainer data-testid="property-score-summary-card">
					<AnnotationContainer>
						<AnnotationTextContainer>
							<StyledTitle type="IB110" lineHeight="sm" htmlElement="h4">{internal_name}</StyledTitle>
							<StyledParagraph type="IR100" lineHeight="md">
								The higher your score, the more bookings you'll receive. Top scoring properties attract 5X more bookings!
							</StyledParagraph>
						</AnnotationTextContainer>
						<AnnotationButtonContainer>
							<Button
								text="Boost your score now"
								fill="light"
								size="regular"
								onClick={() => {
									navigate(`property-scores/${id}/score`);
								}}
							/>
						</AnnotationButtonContainer>
					</AnnotationContainer>
					<PropertyScoreWheel score={totalScore ?? 0} />
				</AnnotatedPictogramContainer>
			</InfoCard>
		);
	};
